import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '9.3696 5.636'
  const rightTransformOrigin = '38.6304 5.636'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0 9.32661C0 9.32661 16.1967 5.33655 17.6134 4.63655C19.0301 3.93655 16.8799 -1.94339 5.66683 1.82661C0.843997 3.44661 0 9.32661 0 9.32661Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M1.36997 5.63599C1.36997 5.63599 3.01674 3.23604 4.46269 2.66278C7.25417 1.54543 15.729 3.48867 17.1448 2.79883C18.5607 2.11869 13.0982 -1.26248 6.10946 0.787632C1.23943 2.21591 1.36997 5.63599 1.36997 5.63599Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M48 9.32661C48 9.32661 31.8033 5.33655 30.3866 4.63655C28.9699 3.93655 31.1201 -1.94339 42.3332 1.82661C47.156 3.44661 48 9.32661 48 9.32661Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M46.63 5.63599C46.63 5.63599 44.9833 3.23604 43.5373 2.66278C40.7458 1.54543 32.271 3.48867 30.8552 2.79883C29.4393 2.11869 34.9018 -1.26248 41.8905 0.787632C46.7606 2.21591 46.63 5.63599 46.63 5.63599Z"
          fill={fill}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="9.0001"
            y1="10.8401"
            x2="9.0001"
            y2="2.88695"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.215796" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="38.9999"
            y1="10.8401"
            x2="38.9999"
            y2="2.88695"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.215796" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
